export default "__VITE_ASSET__BYTVl14E__"